import DummyProductPage from '@/product-modules/dummy/DummyProductModulePage'
import ApsReportingPage from '@/product-modules/auto-prospecting/ReportingPage'
import ApsTodayDataPage from '@/product-modules/auto-prospecting/TodayDataPage'
import ApsTriggerPage from '@/product-modules/auto-prospecting/TriggerPage'

import Recruitment from '@/product-modules/recruitment/Recruitment'
import RecruitmentApplications from '@/product-modules/recruitment/RecruitmentApplications'

import Videoettes from '@/product-modules/videoettes/Videoettes'
import VideoettesSettings from '@/product-modules/videoettes/Settings'
import VideoettesPresets from '@/product-modules/videoettes/Presets'
import VideoBrandingManager from '@/product-modules/videoettes/VideoBrandingManager'
import MyBrandingVideo from '@/product-modules/videoettes/MyBrandingVideo'
import BrandingPreSets from '@/product-modules/videoettes/BrandingPreSets'

import EvaluateSettings from '@/product-modules/evaluate/Settings'
import EngageLeads from '@/product-modules/engage/Leads'
import EngageEmbed from '@/product-modules/engage/Embed'
import EngageSettings from '@/product-modules/engage/Settings'

import MortgageServicesForm from '@/product-modules/mortgage-services/FormPage'

import SmartViewingScheduleViewing from '@/product-modules/smart-viewing/ScheduleViewing'
import SmartViewingViewings from '@/product-modules/smart-viewing/Viewings'

import PreValuationEmailManager from '@/product-modules/valuation-email-manager/PreValuationEmailManager'
import PostValuationEmailManager from '@/product-modules/valuation-email-manager/PostValuationEmailManager'

import LettingsPreValuationEmailManager from '@/product-modules/valuation-email-manager/LettingsPreValuationEmailManager'
import LettingsPostValuationEmailManager from '@/product-modules/valuation-email-manager/LettingsPostValuationEmailManager'

import ValuationReportsIndex from '@/product-modules/valuation-reports/ValuationReportsIndex'

import AutomaticReferralsPage from '@/product-modules/referrals/AutomaticReferralsPage'
import SentReferralsPage from '@/product-modules/referrals/SentReferralsPage'
import ReceivedReferralsPage from '@/product-modules/referrals/ReceivedReferralsPage'
import CreateReferralPage from '@/product-modules/referrals/CreateReferralPage'
import ReferralTermsPage from '@/product-modules/referrals/ReferralTermsPage'
import FindAnAgentPage from '@/product-modules/referrals/FindAnAgentPage'

import EzineCampaignsPage from '@/product-modules/ezines/EzineCampaignsPage'
import EzineEditionsPage from '@/product-modules/ezines/EzineEditionsPage'
import EzinePagesPage from '@/product-modules/ezines/EzinePagesPage'

import InsightReportsPage from '@/product-modules/insight/InsightReportsPage'
import SocialMediaNetwork from '@/product-modules/social-media-network/SocialMediaNetwork'

import MsfReport from '@/product-modules/msf-reports/MsfReport'
import PropertyAssetPage from '@/product-modules/property-asset/PropertyAssetPage'
import PropertyComparisonPage from '@/product-modules/property-comparison/PropertyComparisonPage'
import PropertyComparisonTool from '@/product-modules/property-comparison/PropertyComparisonTool'

import CompletionReportPendingPage from '@/product-modules/completion-report/CompletionReportPendingPage'
import CompletionReportHistoryPage from '@/product-modules/completion-report/CompletionReportHistoryPage'

import DocumentGeneratorCreatePage from '@/product-modules/documents/DocumentGeneratorCreatePage'
import DocumentGeneratorSettingsPage from '@/product-modules/documents/DocumentGeneratorSettingsPage'
import DocumentGeneratorSavedPage from '@/product-modules/documents/DocumentGeneratorSavedPage'

import FlockDirectory from '@/product-modules/flock-directory/FlockDirectory'

import News from '@/product-modules/news/News'

export default {
  DummyProductPage,
  ApsReportingPage,
  ApsTodayDataPage,
  ApsTriggerPage,
  Recruitment,
  RecruitmentApplications,
  Videoettes,
  EvaluateSettings,
  EngageLeads,
  EngageEmbed,
  EngageSettings,
  MortgageServicesForm,
  VideoettesSettings,
  VideoettesPresets,
  VideoBrandingManager,
  MyBrandingVideo,
  BrandingPreSets,
  SmartViewingScheduleViewing,
  SmartViewingViewings,
  PreValuationEmailManager,
  PostValuationEmailManager,
  LettingsPreValuationEmailManager,
  LettingsPostValuationEmailManager,
  ValuationReportsIndex,
  AutomaticReferralsPage,
  SentReferralsPage,
  ReceivedReferralsPage,
  CreateReferralPage,
  ReferralTermsPage,
  FindAnAgentPage,
  EzineCampaignsPage,
  EzineEditionsPage,
  EzinePagesPage,
  InsightReportsPage,
  SocialMediaNetwork,
  MsfReport,
  CompletionReportPendingPage,
  CompletionReportHistoryPage,
  PropertyAssetPage,
  PropertyComparisonPage,
  DocumentGeneratorCreatePage,
  DocumentGeneratorSettingsPage,
  DocumentGeneratorSavedPage,
  News,
  FlockDirectory,
  PropertyComparisonTool
}
